import React, { useState } from 'react'
import BookingWidget from '../BookingWidget'
import CheckIn from './CheckIn'
import Modify from './Modify'

const AppTabs = () => {
  const { dictionary, configuration, hertzLogo } = window.appTabsData
  const [selectedTab, setSelectedTab] = useState('book')

  const tabs = [
    {
      id: 'book',
      label: dictionary.bookTabLabel,
      icon: 'icon-car-solid',
    },
    {
      id: 'checkIn',
      label: dictionary.checkInTabLabel,
      icon: 'icon-check-in',
    },
    {
      id: 'modify',
      label: dictionary.modifyTabLabel,
      icon: 'icon-modify',
    },
  ]

  return (
    <div className="s-app-tabs">
      <div className="s-app-tabs__tabs-container">
        {tabs.map(({ id, label, icon }) => (
          <div
            key={id}
            className={`s-app-tabs__tab ${
              selectedTab === id ? 's-app-tabs__tab--selected' : ''
            }`}
            onClick={() => setSelectedTab(id)}>
            <i className={icon}></i>
            <span>{label}</span>
          </div>
        ))}
      </div>
      <div className="page-container s-app-tabs__content">
        {selectedTab === 'book' && <BookingWidget mobileApp />}
        {selectedTab === 'checkIn' && (
          <CheckIn
            dictionary={dictionary}
            endpointCountries={configuration.endpointCountries}
            endpointCheckIn={configuration.endpointCheckIn}
          />
        )}
        {selectedTab === 'modify' && (
          <Modify
            dictionary={dictionary}
            endpoint={configuration.endpointModify}
          />
        )}
        <div className="s-app-tabs__footer">
          <span>{dictionary.poweredBy}</span>
          <img src={hertzLogo} alt="Hertz" />
        </div>
      </div>
    </div>
  )
}

export default AppTabs
